import React from 'react';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { actionCreators as authActions } from 'common/auth/store';
import { ajaxActions } from 'common/ajax/store';

class AddAccountRedirect extends React.Component {
  componentDidMount() {
    const { setAjaxStatus, silentSignin, history } = this.props;
    setAjaxStatus(true);
    silentSignin(() => {
      setAjaxStatus(false);
      history.push({
        pathname: '/accounts',
        state: { accountAdded: 1 }, //pass this to the account selection page to display a successful toast message
      });
    });
  }

  render() {
    return null;
  }
}

export default compose(
  withRouter,
  connect(null, {
    silentSignin: authActions.silentSignin,
    setAjaxStatus: ajaxActions.setAjaxStatus,
  })
)(AddAccountRedirect);
